import { render } from "./Footer.vue?vue&type=template&id=4eaf952a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "../../../public/assets/cssLanding/bootstrap.min.css?vue&type=style&index=0&id=4eaf952a&scoped=true&lang=css&external"
import "../../../public/assets/fontsLanding/iconfonts.css?vue&type=style&index=1&id=4eaf952a&scoped=true&lang=css&external"
import "../../../public/assets/cssLanding/plugins.css?vue&type=style&index=2&id=4eaf952a&scoped=true&lang=css&external"
import "../../../public/assets/cssLanding/style.css?vue&type=style&index=3&id=4eaf952a&scoped=true&lang=css&external"
import "../../../public/assets/cssLanding/responsive.css?vue&type=style&index=4&id=4eaf952a&scoped=true&lang=css&external"
import "../../../public/assets/cssLanding/color.css?vue&type=style&index=5&id=4eaf952a&scoped=true&lang=css&external"
import "./Footer.vue?vue&type=style&index=6&id=4eaf952a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eaf952a"]])

export default __exports__